import noResultImg from '@/assets/figma/drug-no-result.svg';
import { cn } from '@/shared/lib/utils';
import type { ReactNode } from 'react';

/**
 * M-11 검색 결과 없음 (Figma 886:13019) — icon_noResult 160 + 20 Bold / 16 SemiBold 회색 문구 (간격 4).
 * 검색어 없이 /drugs로 들어온 경우도 같은 모양으로 GNB 검색을 안내한다.
 */
export const DrugEmptyView = ({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center text-center',
      className,
    )}
  >
    <img src={noResultImg} alt="" width={160} height={160} />
    <div className="flex flex-col items-center gap-1 text-fg-tertiary">
      <p className="text-heading-20-b">{title}</p>
      <p className="text-body-16-sb">{description}</p>
    </div>
    {action && <div className="mt-6">{action}</div>}
  </div>
);
